/**
 * Blog post metadata. Add new posts here in any order.
 */
export const blogPosts = [
  {
    slug: "5-website-checks-you-can-automate",
    title: "The 5 website checks you should automate today",
    date: "2026-02-01",
    excerpt: "Uptime, SSL expiry, domain expiry, redirects, and page speed — the minimum monitoring stack for any business site.",
    readingTime: "6 min read",
    tags: ["Website Monitoring", "Uptime", "SSL", "Automation"],
    category: "Website Monitoring",
    author: "SiteScope",
    thumbnail: "/blog/5-website-checks-thumb.png",
    image: "/blog/5-website-checks-thumb.png",
  },
];

/** All posts, newest first (descending by date). */
export function getAllPosts() {
  return [...blogPosts].sort((a, b) => (a.date > b.date ? -1 : 1));
}

export function getPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug) || null;
}

/** Returns { prev, next } for navigation. prev is older, next is newer. */
export function getPrevNext(slug) {
  const sorted = getAllPosts();
  const idx = sorted.findIndex((p) => p.slug === slug);
  if (idx === -1) return { prev: null, next: null };
  return {
    prev: idx > 0 ? sorted[idx - 1] : null,
    next: idx < sorted.length - 1 ? sorted[idx + 1] : null,
  };
}
